import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMusic = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-music4-icon lucide-music-4",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9 18V5l12-2v13" }),
		/* @__PURE__ */ _jsx("path", { d: "m9 9 12-2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 18,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 16,
			r: 3
		})
	]
});
export default SvgMusic;
